import { isIE } from '@jfs/ui-new/src/utils/utils'
import { configure } from 'mobx'
if (isIE()) {
  configure({ useProxies: 'never' })
}
